var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, } from 'react';
import gsap from 'gsap';
import useWatch from '../../../../utils/hooks/useWatch';
import ContentInformation from '../InformationColumn/ContentInformation';
export default function FeatureListItem(_a) {
    var featureObject = _a.featureObject, setActiveContentInformation = _a.setActiveContentInformation, activeContentInformation = _a.activeContentInformation, textColorItemClassDefault = _a.textColorItemClassDefault, textColorHoverClassActive = _a.textColorHoverClassActive;
    var isItemActive = useMemo(function () {
        return (activeContentInformation &&
            activeContentInformation.order === featureObject.order) ||
            window.visualViewport.width < 1024;
    }, [activeContentInformation]);
    var activateFeatureItem = function () {
        setActiveContentInformation(featureObject);
    };
    var deactivateFeatureItem = function (isBlur) {
        if (isBlur === void 0) { isBlur = false; }
        var isMobileViewport = window.visualViewport.width < 1024;
        if (!isBlur && !isMobileViewport) {
            setActiveContentInformation(null);
        }
    };
    var handleKeyPress = function (e) {
        if (e.keyCode === 27) {
            deactivateFeatureItem();
            featureItemLinkRef.current.blur();
        }
    };
    useEffect(function () {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.jobs__title__initial--text',
                start: 'top center',
            },
        });
        tl.fromTo('.jobs__features__item__title', {
            opacity: 0,
            duration: 0.5,
        }, {
            opacity: 1,
            //color: 'red',
            duration: 0.5,
            delay: 0.2,
            stagger: 0.2,
        });
    }, []);
    useWatch(function () {
        var isMobileViewport = window.visualViewport.width < 1024;
        if (isMobileViewport) {
            return;
        }
        if (!isItemActive) {
            featureItemLinkRef.current.blur();
        }
    }, isItemActive);
    var orderWithTwoDigits = ("" + featureObject.order).padStart(2, '0');
    var featureItemLinkRef = useRef(null);
    return (_jsxs("li", __assign({ onMouseEnter: function () { return activateFeatureItem(); }, onClick: function () { return activateFeatureItem(); }, className: "jobs__features__item relative" }, { children: [_jsx("a", __assign({ onFocus: function () { return activateFeatureItem(); }, onBlur: function () { return deactivateFeatureItem(true); }, onKeyUp: handleKeyPress, role: "button", tabIndex: 0, href: featureObject.ctaLink, onClick: function (e) {
                    if (!featureObject.ctaLink)
                        e.preventDefault();
                }, target: "" + (featureObject.target ? '_blank' : ''), ref: featureItemLinkRef, className: "jobs__features__item__wrapper " + (isItemActive
                    ? "jobs__features__item__wrapper--active " + textColorItemClassDefault + " opacity-100"
                    : "jobs__features__item__wrapper--default " + textColorHoverClassActive + " opacity-60 ") + " flex cursor-pointer select-none items-center pb-6 text-left text-3xl transition-all duration-300 ease-in-out focus:outline-none md:space-x-7 md:pl-0 md:pb-10 lg:pr-0 lg:space-x-14 lg:border-t-0" }, { children: _jsxs("h3", __assign({ className: "jobs__features__item__title  block w-full  max-w-full  overflow-x-auto break-words pt-6 text-left font-semibold text-white md:overflow-x-visible md:pt-10 lg:ml-0 lg:whitespace-normal lg:leading-tight" }, { children: [featureObject.title, isItemActive && _jsx(ContentInformation, { mainContent: featureObject }, void 0)] }), void 0) }), void 0),
            _jsx("span", { className: " border-item absolute bottom-0 h-[1px] w-full max-w-full bg-engray transition-all duration-500 ease-in-out lg:max-w-none " + (isItemActive ? 'opacity-100' : 'opacity-60') }, void 0)] }), featureObject.title));
}
